<template>
  <div :class="containerClass">
    <ul id="menu-social-media-menu-1" class="menu">
      <li class="">
        <a target="_blank" rel="noopener" href="https://www.instagram.com/radiokanalk/" aria-label="Instagram">
          <i class="fab fa-instagram" aria-hidden="true">
          </i>
        </a>
      </li>
      <li class="">
        <a target="_blank" rel="noopener" href="https://tidal.com/@kanalk" aria-label="Spotify">
          <i class="fa-brands fa-tidal" aria-hidden="true"></i>
        </a>
      </li>
      <li class="">
        <a target="_blank" rel="noopener" href="https://open.spotify.com/user/radiokanalk" aria-label="Spotify">
          <i class="fab fa-spotify" aria-hidden="true"></i>
        </a>
      </li>
      <li class="">
        <a target="_blank" rel="noopener" href="https://www.youtube.com/user/KanalKRadio" aria-label="Youtube">
          <i class="fab fa-youtube" aria-hidden="true"></i>
        </a>
      </li>
      <li class="custom">
        <a target="_blank" rel="noopener" href="https://mx3.ch/radios/kanalk" aria-label="Youtube">
          <div class="">
            <svg-mx3 />
          </div>
        </a>
      </li>
      <li class="custom invert">
        <a target="_blank" rel="noopener" href="https://mx3.ch/radios/kanalk" aria-label="Youtube">
          <div class="">
            <svg-mx3-invert />
          </div>
        </a>
      </li>
      <li class="conditional">
        <a target="_blank" rel="noopener" href="https://www.facebook.com/radiokanalk/" aria-label="Facebook">
          <i class="fab fa-facebook-f" aria-hidden="true"></i>
        </a>
      </li>
      <li class="conditional">
        <a target="_blank" rel="noopener" href="mailto:info@kanalk.ch" aria-label="Kontakt">
          <i class="fa fa-envelope" aria-hidden="true"></i>
        </a>
      </li>
      <li v-if="newsletter" class="">
        <router-link to="/newsletter" @click.prevent="vuexStore.dispatch('closeMenuBarFull')">Newsletter</router-link>
      </li>

    </ul>
  </div>
</template>

<script>
import SvgMx3 from "@/components/svg/SvgMx3.vue";
import SvgMx3Invert from "@/components/svg/SvgMx3Invert.vue";

export default {
  name: "MenuSocials",
  components: {SvgMx3Invert, SvgMx3},
  props: {
    containerClass: String,
    newsletter: Boolean
  }
}
</script>

<style scoped>
.menu-social > ul {
  display: flex;
  align-items: center;
}

.menu-social > ul > li {
  margin-right: 1rem;
}

.menu-social > ul > li > a {
  font-size: 1rem;
}

.menu-social > ul > li.custom > a > div {
  width: 25px;
  /*height: 16px;*/
  position: relative;
  transform: translateY(-2px);
  margin-right: -0.3rem;
}

.menu-social > ul > li.custom > a > div > svg {
  position: absolute;
}


header .menu-social > ul > li {
  margin-right: 0.7rem;
}

header .menu-social > ul > li > a {
  font-size: 1.2rem;
  color: var(--color-black);
}

header .menu-social > ul > li.custom > a > div {
  width: 1.75rem;
  height: 1rem;
  transform: translateY(0px);
}

header .menu-social.header > ul > li {
  transition: margin-right ease var(--transition-time1);
}

header .menu-social.header > ul > li > a {
  transition: font-size ease var(--transition-time1);
}

header .menu-social.header > ul > li.custom > a > div {
  transition: width ease var(--transition-time1), height ease var(--transition-time1);
}

header #menubar .menu-social > ul > li.custom > a > div {
  transform: translateY(-5px);
}

header .menu-social > ul > li.custom.invert, footer .menu-social > ul > li.custom:not(.invert) {
  display: none;
}

header .menu-social > ul > li:last-of-type {
  margin-right: 0;
}

header .menu-social > ul > li > a:hover {
  color: var(--color-random2);
}

@media (max-width: 1600px) {

  #content-wrapper header .menu-social.header > ul > li.conditional {
    display: none;
  }
}

@media (max-width: 1500px) {

  #content-wrapper:not(.player-display-full) header .menu-social.header > ul > li {
    margin-right: 0.5rem;;
  }

  #content-wrapper:not(.player-display-full) header .menu-social.header > ul > li > a {
    font-size: 1.1rem;
  }

  #content-wrapper:not(.player-display-full) header .menu-social.header > ul > li.custom > a > div {
    width: 1.5rem;
    height: initial;
  }
}

@media (max-width: 1300px) {
  #content-wrapper.player-display-default.landing header .menu-social.header,
  #content-wrapper:not(.landing) header .menu-social.header {
    display: none;
  }
}

@media (max-width: 991px) {
  header .menu-social.header  {
    display: none;
  }

  #menubar .menu-social > ul {
    width: 100%;
    justify-content: space-between;
  }

  #menubar .menu-social > ul > li {
    /*flex: 1;*/
    /*text-align: center;*/
  }

  #menubar .menu-social > ul > li > a {
    font-size: 1.5rem;
  }

  #menubar .menu-social > ul > li.custom > a > div {
    width: 2.8rem;
  }

  footer .menu-social > ul > li > a {
    font-size: 1.3rem;
  }

  footer .menu-social > ul > li.custom > a > div {
    width: 1.5rem;

  }
}
</style>